/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as VotesAct from '../../Actions/VoteActions';
import { getGlyphe, toCalendrier, toDate, fromNow } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import TableauV from '../TableauV';
import { obtenirVotantAvecVotes} from '../../App_Code/API';
import FicheVote from './FicheVote';


class MesVotes extends Component {
    constructor(props) {
        super(props);
        let NumR=0
        if(this.props.location.state && this.props.location.state.NumReunion>0) {
            NumR=this.state.StateNumReunion.NumReunion
            this.props.actions.VoteMajNumReunion(NumR)
        }
        if(this.props.match.params.id>0 && NumR<1) {
            NumR=this.props.match.params.id
            this.props.actions.VoteMajNumReunion(NumR)
        }
        if(NumR<1) {
            NumR=this.props.NumReuSel
        }
        const lareuTab = this.props.LsReunions.filter(Reu => Reu.NumReunion == NumR);
        let lareu = null
        if (lareuTab.length>0) {
            lareu=this.props.LsReunions.filter(Reu => Reu.NumReunion == NumR)[0]
        };

        this.state = {
            StateNumReunion: NumR,
            StateReunion: lareu,
            StateVotant: null,
            StateLsVotes:null,
            DialogVote:false,
            indexini: this.props.location.state ? this.props.location.state.index : 0,
        };

    }
    componentDidMount() {
        console.log ("jfqsdjkyhgvsdfuihgsdfui")
        if (this.state.StateNumReunion<1) {return false}
        obtenirVotantAvecVotes(this.state.StateNumReunion).then((data) => {
            this.setState({ StateVotant: data });
            this.setState({ StateLsVotes: data.LsVotes });
        });
    }

    toggleDialogVote = () => {
        this.setState({
            DialogVote: !this.state.DialogVote,
        });

    };


    render() {
        const { NumReuSel, LsReunions } = this.props;
        const {
            StateNumReunion, StateReunion, StateVotant, StateLsVotes, StateNumVote,
        } = this.state;
        if (!StateReunion) { return false }
        if (StateReunion.EtatReu!=1 || StateReunion.EtatVotePro>=4) { return false }
        if (StateVotant && StateVotant.FormRetourType>0 ) { return false }
        return (
            <React.Fragment>
                <div className="d-flex justify-content-between">
                    <div  className="media media-body small">
                        {StateReunion.Nom}<br/>
                        Le {toDate(StateReunion.DateDebut, 'DD/MM/YYYY')} à {toDate(StateReunion.DateDebut, 'HH:mm')}
                    </div>
                    <div  className="media media-body small">&nbsp;</div>
                    <div  className="media media-body small text-right" style={{justifyContent:"end"}}>
                        {StateReunion.VoteFerme ? "Votes fermé depuis le " :"Votes ouverts jusqu'au "} {toDate(StateReunion.VoteFin, 'DD/MM/YYYY')}
                    </div>
                </div><br/>
                {this.state.StateLsVotes ? <FicheVote lsvotes={this.state.StateLsVotes} NumReu={this.state.StateNumReunion} indexini={this.state.indexini} />: ''}

                </React.Fragment>
        );
    }
}
MesVotes.displayName = 'MesVotes';
MesVotes.requiredProps = [
    'NumReuSel', // Num Reunion selectionnée pour le vote
    'LsReunions', // Liste Reunions trouvées
];

function mapStateToProps({ 
    CopStore: {
        Cop: { LsReunions },
    },
    VoteStore: { NumReuSel, Votant },
}) {
    return {NumReuSel, LsReunions };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(VotesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(MesVotes));



// WEBPACK FOOTER //
// ./src/components/MonAG/MesVotes.js